import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-upload-photo',
    templateUrl: './upload-photo.component.html',
    styleUrls: ['./upload-photo.component.scss'],
    standalone: false
})
export class UploadPhotoComponent implements OnInit {
  toggleClass: boolean = true;
  redirectTo: string = '/profile';

  constructor(
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._route.queryParams
      .subscribe(params => {
        if (params.redirectTo) {
          this.redirectTo = `/${params.redirectTo}`
        }
      });
  }

}
